import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

const StContainer = styled(FlexColumn)`
  height: 100%;
 
  ${({ theme }) => `
  padding-top: 0;

  @media ${breakpoints.s} {
    padding-top:  ${theme.UI.SpacingPx.Space5};
  }
  @media ${breakpoints.m} {
    padding-top: ${theme.UI.SpacingPx.Space8};
  }

  @media ${breakpoints.l} {
    padding-top: ${theme.UI.SpacingPx.Space12};
  }

`}


  @media ${breakpoints.s} {
    width: 500px;
    max-width: 500px;
  }
}`

const StContainerWithPagePadding = styled.div`
  ${({ theme }) => `
  gap: ${theme.UI.SpacingPx.Space2};
  padding: 0 ${theme.UI.SpacingPx.Space6};
  padding-top: ${theme.UI.SpacingPx.Space4};

  @media ${breakpoints.s} {
    padding: 0 ${theme.UI.SpacingPx.Space6};
  }

  @media ${breakpoints.m} {
    padding: 0 ${theme.UI.SpacingPx.Space12};
  }

  @media ${breakpoints.l} {
    padding: 0 ${theme.UI.SpacingPx.Space20};
  }
  `}
`

const StIcon = styled(FontAwesomeIcon)`
  ${({ theme }) => `
    width: ${theme.UI.SpacingPx.Space6};
    height: ${theme.UI.SpacingPx.Space6};
  `}
`

const StTabItem = styled.div<{ active: boolean }>`
position: relative;
cursor: pointer;
text-align: center;

display: flex;
flex-direction: row;
align-items: center;

color: ${({ theme }) => theme.Colors.Theme.Primary};

gap: ${({ theme }) => theme.UI.SpacingPx.Space1};

z - index: 1;
  ${({ theme, active }) => `
    padding: ${theme.UI.SpacingPx.Space2} ${theme.UI.SpacingPx.Space4};
    border-radius: 30px;
    background-color: ${active ? '#EFEFF6' : 'transparent'};
  `}
`

const StMessageScrollContainer = styled(FlexColumn)`
  height: 100%;
  overflow: auto;
`

const StNotificationMessage = styled.div<{ read: boolean }>`
  ${({ theme, read }) => `
    padding: ${theme.UI.SpacingPx.Space4} 0;
    border-radius: ${theme.UI.SpacingPx.Space2};
    background-color: ${read ? 'transparent' : '#F9F9FF'};
  `}
`

export { StContainer, StContainerWithPagePadding, StIcon, StMessageScrollContainer, StNotificationMessage, StTabItem }
